import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetMe = {
  getMe: { data: null, loading: false, error: null },
};

export const getMe = createAsyncThunk('user/getMe', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`/users/me`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetMe = {
  [getMe.pending]: (state) => {
    state.getMe.loading = true;
    state.getMe.error = null;
  },
  [getMe.fulfilled]: (state, action) => {
    state.getMe.loading = false;
    state.getMe.data = action.payload;
    state.getMe.error = null;
  },
  [getMe.rejected]: (state, action) => {
    state.getMe.loading = false;
    state.getMe.error = action.payload;
  },
};
